<template>
    <div class="signBox">
        <breadcrumb :routerList="[{to:'/agent/agentCopy',title:'经销商管理'},{title:'经销商详情'}]"/>
        <div class="imgBox" v-loading="loading">
            <div class="bannerBox">
                <div class="whiteBox">
                    <div>
                        <div class="h-pieceTitle2" style="margin-bottom: 0;">
                            <h1>经销商类型</h1>
                        </div>
                        <el-radio-group v-model="radio" disabled @change="changeType" style="margin:20px 0 ;">
                            <el-radio-button label="国内客户"></el-radio-button>
<!--                            <el-radio-button label="上海直销"></el-radio-button>-->
                            <el-radio-button label="海外客户"></el-radio-button>
                        </el-radio-group>
                        <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
                            <h1>直单类型</h1>
                        </div>
                        <div style="margin-top: 5px;">
                            <span>
                            <el-switch
                                    disabled
                                    v-model="isZhiDan"
                                    class="zhidangc"
                                    active-text="是否是直单用户"
                                    style="margin-bottom: 0.2rem"
                                    inactive-text="">
                            </el-switch>
                            </span>
                            <span>
                                <el-switch
                                    style="margin-left: 50px;margin-bottom: 0.2rem"
                                    v-model="isExpandAuthority"
                                    active-text="是否开通海外下单权限"
                                    :disabled="this.flag==='2'||this.flag==='3'||this.flag==='4'">
                                </el-switch>
                            </span>
                            <span>
                                 <el-switch
                                         style="margin-left: 50px;margin-bottom: 0.2rem"
                                         v-model="isFenxiao"
                                         active-text="是否分销商1.0"
                                         inactive-text=""></el-switch>
                            </span>
                        </div>
                        <div class="h-pieceTitle2" style="margin-bottom: 0;">
                            <h1>客户资质信息</h1>
                        </div>
                        <div class="signsign">
                            <div class="h-formLine" style="margin-top:0.38rem">
                                <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right"
                                        ref="formLabelAlign1c" :inline="true"
                                        :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                                    <el-form-item label="公司名称" class="h-elformWrap-2" prop="customerName1">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.customerName1"
                                                :title="formLabelAlign1.bscUserInfoAgentBasic.customerName1"
                                                placeholder="">
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="客户编码" class="h-elformWrap-2" prop="usercode">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.usercode"
                                                placeholder="">
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="客户" class="h-elformWrap-2" v-if="this.agentType != 3" prop="scale">
                                        <el-select disabled v-model="formLabelAlign1.bscUserInfoAgentBasic.scale"
												:class="{'ljjSelectdisabled':true}"
                                                placeholder="小规模经营者">
                                            <el-option label="小规模经营者" value="0"></el-option>
                                            <el-option label="一般纳税人" value="1"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="公司地址" class="h-elformWrap-2" prop="companyAddress">
                                        <el-input readonly
                                            v-model="formLabelAlign1.bscUserInfoAgentBasic.companyAddress"
                                            :title="formLabelAlign1.bscUserInfoAgentBasic.companyAddress"
                                            placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="公司邮箱" class="h-elformWrap-2" prop="email">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.email"></el-input>
                                    </el-form-item>
                                    <el-form-item label="公司性质" class="h-elformWrap-2" v-if="this.agentType != 3" prop="companytype">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.companytype"
                                                placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="成立时间" class="h-elformWrap-2" prop="founded">
                                        <el-date-picker
                                                disabled
                                                v-model="formLabelAlign1.bscUserInfoAgentBasic.founded"
                                                type="date"
												:class="{'ljjSelectdisabled':true}"
                                                placeholder="">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item label="总经理姓名" class="h-elformWrap-2" prop="legal">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.legal"
                                                placeholder=""></el-input>
                                    </el-form-item>
                                   <!-- <el-form-item label="主营业务" class="h-elformWrap-2" prop="business">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.business"
                                                placeholder=""></el-input>
                                    </el-form-item>-->
                                    <el-form-item label="销售人员数量" class="h-elformWrap-2" prop="legal">
                                      <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.personnelNum"
                                      ></el-input>
                                    </el-form-item>
                                    <el-form-item label="总经理联系方式" class="h-elformWrap-2" prop="legal" >
                                      <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.legalPhone"
                                      ></el-input>
                                    </el-form-item>
                                    <el-form-item label="经营其他品牌" class="h-elformWrap-2" prop="legal">
                                      <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.brand"
                                      ></el-input>
                                    </el-form-item>
                                    <el-form-item label="联系人" class="h-elformWrap-2" prop="name1">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.name1"
                                                placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="联系人手机号" class="h-elformWrap-2" prop="phoneNumber1">
                                        <el-input readonly
                                                v-model="formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone"
                                                placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="所在国家" class="h-elformWrap-2" prop="country">
                                        <brselectlazy category="YLCountry_agent"
                                            :v="formLabelAlign1.bscUserInfoAgentBasic.country"
                                            v-model="formLabelAlign1.bscUserInfoAgentBasic.country"
                                            :class="{'ljjSelectdisabled':true}"
                                            :clearable="true" disabled/>
                                    </el-form-item>
                                    <el-form-item label="直销/分销" v-if="this.agentType == '3'" class="h-elformWrap-2" prop="isZhidan">
                                        <el-select disabled v-model="formLabelAlign1.bscUserInfoAgentBasic.isZhidan"
												:class="{'ljjSelectdisabled':true}"
                                                placeholder="">
                                            <el-option label="直销" value="1"></el-option>
                                            <el-option label="分销" value="0"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="所在地区" class="h-elformWrap-2" prop="region"
                                            v-show="this.isShowMassage === true ? true:false && this.agentType != '3'">
                                        <brselectlazy category="YLRegion"
                                            :v="formLabelAlign1.bscUserInfoAgentBasic.region"
                                            v-model="formLabelAlign1.bscUserInfoAgentBasic.region"
                                            :class="{'ljjSelectdisabled':true}"
                                            :clearable="true" disabled/>
                                    </el-form-item>
                                    <el-form-item label="所在城市" class="h-elformWrap-2" prop="companyAddress" v-if="this.isShowMassage !== true ? false:true && this.agentType != '3'">
                                        <el-select
                                                filterable
                                                disabled
												:class="{'ljjSelectdisabled':true}"
                                                v-model="formLabelAlign1.bscUserInfoAgentBasic.contactCity"
                                                placeholder="">
                                            <el-option v-for="(item,index) in addli" :key="index" :label="item" :value="item">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bannerBox2">
                    <div class="h-row h-mrt1">
                        <div class="h-rowIn">
                            <div class="h-rowBox">
                                <div class="h-rowCon">
                                    <div class="h-pieceIn2">
                                        <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                        <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                            <h1>审核信息</h1>
                                        </div>
                                        <div class="h-pieceCon2 ">
                                            <div class="h-formLine weekplandetail11" style="position: relative;">
                                                <el-form :inline="true" :model="formLabelAlign1.bscUserInfoAgentBasic">
                                                    <el-form-item label="审批意见" class="h-elformWrap-2 newBox"
                                                                style="width: 100%!important;">
                                                        <el-input
                                                                v-model="formLabelAlign1.bscUserInfoAgentBasic.auditMindfx2"
                                                                placeholder="请输入"></el-input>
                                                    </el-form-item>
                                                </el-form>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div style="text-align: center;margin-top: 0.3rem">
                <el-button class="h-btn h-bBtn" :class="{'h-bgwhite':this.flag!=='2'&&this.flag!=='5'}"
                        @click="goBack">返回
                </el-button>
                <el-button class="h-btn h-bBtn h-bgred"
                        v-if="this.flag==='3'||this.flag==='4'"
                        @click="update('formLabelAlign1')">驳回
                </el-button>
                <el-button class="h-btn h-bBtn h-bggreen" @click="update()"
                        v-if="this.flag==='3'||this.flag==='4'">通过
                </el-button>
                <el-button class="h-btn h-bBtn" @click="viewpress">
                    审批跟踪
                </el-button>

            </div>
            <viewhistory :visible.sync="showhistory" v-if="showhistory"
                        :id="instid"/>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService';
    import agentCopyService from "../../../api/loud/agent/agentCopyService";

    export default {
        data() {
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    if (this.check.checkpassword !== '') {
                        this.$refs.formLabelAlign1a.validateField('checkpassword');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.formLabelAlign1.bscUserInfo.password) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            var validateCompany = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入公司名称'));
                } else if (value !== '') {
                    ss.SignService.checkCompany(value).then(response => {
                        this.companyData = response.obj.data;
                        console.log(response, '验证公司信息')
                        if (response.obj.status === '200') {
                            callback();
                            this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress = this.companyData.address;
                            // this.formLabelAlign1.bscUserInfoAgentBasic.http = this.companyData.websites[0].web_url;
                            this.formLabelAlign1.bscUserInfoAgentBasic.companytype = this.companyData.econ_kind;
                            this.formLabelAlign1.bscUserInfoAgentBasic.founded = this.companyData.start_date;
                            this.formLabelAlign1.bscUserInfoAgentBasic.regmoney = this.companyData.regist_capi;
                            this.formLabelAlign1.bscUserInfoAgentBasic.legal = this.companyData.oper_name;
                            this.formLabelAlign1.bscUserInfoAgentBasic.business = this.companyData.scope;
                            this.formLabelAlign1.bscUserInfoAgentBasic.taxCode = this.companyData.credit_no;
                            this.formLabelAlign1.bscUserInfoAgentBasic.streetRoom = this.companyData.address;
                            this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber = this.companyData.contact.telephone;
                        } else {
                            callback(new Error('请输入正确的公司名称!'));
                        }
                    })

                }
            };
            return {
                value1: true,
                value2: false,
                haveThree6840:false,
                ctLevel: '',
                ND4Level: '',
                ND5Level: '',
                ND6Level: '',
                ct: true,
                ND4: true,
                ND5: true,
                ND6: true,
                checkedlevels: [],
                levels: ['传统产品', 'U血液', 'U试剂', 'U疫苗'],
                checkAll: false,
                isIndeterminate: true,
                havepolicy2017:false,
                have6858: false,
                have6840: false,
                have6854: false,
                have1101: false,
                have2214: false,
                have2215: false,
                have2216: false,
                showhistory: false,
                instid: null,
                showtime: false,
                companyData: null,
                showflag: false,
                have: false,
                have2: false,
                have3: false,
                isZhiDan: false,
                isBlood:false,
                isExpandAuthority:false,
                isFenxiao:false,
                options: [],
                value: [],
                listSelect: [],
                addli: [],
                loadingSelect: false,
                states: [],
                isShowMassage: true,
                radio: '国内客户',
                fileShowFlag: false,
                uploadflag: true,
                delflag: true,
                refid: this.$util.getUuid(),
                loading: false,
                ind: null,
                index: ['a', 'b', 'c', 'd', 'e', 'f', 'h'],
                list: ["我是经销商", "我是供应商"],
                indx: 0,
                formLabelAlign1: {
                    bscUserInfoAgentBasic: {
                        usercode: null,
                        customerNumber: null,
                        accountGroup: null, // 科目组 , 配置项 , 调接口参数: YlCustomerAccountGroup , 字段输入限制:  0210 集团内客户 0260 海外客户 0280 国内客户 根据客户实际情况传入科目组代码  , 特殊限制:   付款条件销售平台更改
                        customerName1: '', // 客户全称1 ,  ,   , 字段输入限制: 客户全名。国内客户要求与证件注册的名称相同 , 特殊限制:   更改账期接口（公司销售视图付款条件字段）
                        customerTitle: null, // 客户标题 ,  ,   , 字段输入限制:  公司 先生 女士 先生和夫人 一般公司类客户数据，可以默认传入“公司”  ,
                        searchTerm: null, // 搜索项 ,  ,   ,   ,
                        postalCode: null, // 邮政编码 ,  ,   ,   ,
                        country: null, // 国家代码 , 配置项 , 调接口参数: YlCountry , 字段输入限制: 传入国家的代码，在list中选择 ,
                        region: null, // 地区 , 配置项 , 调接口参数: YlRegion , 字段输入限制: 传入地区的代码，在国家代码下的list中选择 ,
                        cityStreetRoom: '', // 城市 ,  ,   , 字段输入限制: 客户所在的城市中文名 ,
                        streetRoom: null, // 街道 ,  ,   , 字段输入限制: 客户证件上的注册地址 ,
                        phoneNumber: null, // 电话 ,  ,   , 字段输入限制: 客户证件上注册的电话，开发票使用 , 特殊限制: 最多16位
                        language: null, // 语言代码 , 配置项 , 调接口参数: YlLanguageType , 字段输入限制: 默认传入“ZH” ,
                        faxNumber: null, // 传真 ,  ,   ,   , 特殊限制: 最多16位
                        contactMobilePhone: null, // 移动电话 ,  ,   ,   , 特殊限制: 最多16位
                        companyCodeGeneral: null, // 公司代码(记录0210账户组下客户公司对照关系) , 配置项 , 调接口参数: CompanyCode , 字段输入限制: 当建立集团内客户时，此字段不能为空，需传入集团4位公司代码 ,
                        companyCode: null, // 公司代码 , 是否必填: 是 , 是否配置项: 是 , 值集代码: YlCompanyCode , 注释:
                        taxCode: null, // 纳税人登记号 ,  ,   , 字段输入限制: 客户证件注册的统一信用代码，开发票使用 ,
                        name1: null, // 联系人名称 ,  ,   , 字段输入限制: 客户方联系人的名字 ,
                        phoneNumber1: null, // 联系人电话1 ,  ,   , 字段输入限制: 客户方联系人的电话 , 特殊限制: 最多16位
                        companyAddress: null, // 公司地址名 ,  ,   ,   ,
                        contactCity: null, // 联系人城市 ,  ,   ,   ,
                        appellation: null, // 称谓 ,  ,   , 字段输入限制:  女士 先生  ,
                        partnerFlagSp: null, // 是否有售达方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
                        partnerFlagSh: null, // 是否有送达方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
                        partnerFlagBp: null, // 是否有开票方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
                        partnerFlagPy: null, // 是否有付款方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
                        cucode: null, //创建人编码
                        cuname: null, //创建人名称
                        cdate: null, //创建时间
                        lucode: null, //修改人编码
                        ldate: null, //最后更新时间
                        delflag: null, //可用标志。1：可用，0：删除标志
                        scale: null, //纳税人规模  0：小规模经营者   1：一般纳税人
                        http: null, //公司网址
                        companytype: null, //公司性质
                        founded: null, //成立时间
                        regmoney: null, //注册资本
                        legal: null, //法人姓名
                        introduce: null, //公司简介
                        business: null, //主营
                        achievement: null, //业绩
                        resource: null, //资源
                        email: null, //公司邮箱
                        personnelNum:null,//销售人员数量
                        brand:null,//经营其他品牌
                        legalPhone:null,//总经理联系方式
                        remark: null,//备注
                        auditMindfx2:null,
                    },
                    levelMap: {},
                    OperateType: null,
                    OPERATOR: null,

                },
                data: {},
                check: {
                    checkpassword: ''
                },
                rules: {
                    username: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    password: [{
                        required: true,
                        validator: validatePass,
                        trigger: 'blur'
                    },],
                    checkpassword: [{
                        required: true,
                        validator: validatePass2,
                        trigger: 'blur'
                    },],
                    customerName1: [{
                        required: true,
                        validator: validateCompany,
                        trigger: 'blur'
                    },],
                    // scale:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    companyAddress: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    phoneNumber1: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    // customerName1:
                    //     [
                    //         {required: true, validator: validateCompany, trigger: 'blur'},
                    //     ],
                    cityStreetRoom: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    streetRoom: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    phoneNumber: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    // postalCode:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    // name1:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    // phoneNumber1:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    // vatCode:
                    //     [
                    //         {required: true, message: '请填写必填项', trigger: 'blur'},
                    //     ],
                    bankBranchCode: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    bankName: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    accountHolderName: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    customerGroup1: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                },
                flag: '',
                modelList: [],
                agentType: 1,
                taskstatus: null,
            }
        },
        created() {
            this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
            this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagSp = '1';
            this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagBp = '1';
            this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagPy = '1';
            this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagSh = '1';
            var id = this.$route.query.ywid;
            this.taskid = this.$route.query.taskid;
            this.instid = this.$route.query.instid;
            this.taskstatus = this.$route.query.taskstatus;
            var instid = this.$route.query.instid;
            agentCopyService.getFenxiaoByInstid(instid).then(response => {
                console.log(response, 'response')
                // this.queryLevel(response.obj.customergroupSell);
                this.data = response.obj;
                if (response.obj.permitSell == 2) {
                    this.have2 = true;
                } else if (response.obj.permitSell == 3) {
                    this.have3 = true;
                } else if (response.obj.permitSell == 5) {
                    this.have3 = true;
                    this.have2 = true;
                }
                this.uploadflag = false;
                this.delflag = false;
                this.rules = {};
                if (this.taskstatus == '1') {
                    this.flag = '5';
                } else {
                    this.flag = '4';
                }
                this.refid = this.data.fileidInfo;
                this.fileShowFlag = true;
                this.checkDetail();
                console.log(this.refid, 'refid')
                // if (response.obj.customerassigngroupSell === '0280' && response.obj.agentTypeBas == '1') {
                if (response.obj.agentTypeBas == '1') {
                    this.radio = '国内客户';
                    this.agentType = 2;
                // } else if (response.obj.customerassigngroupSell === '0210' && response.obj.agentTypeBas == '2') {
                } else if (response.obj.agentTypeBas == '2') {
                    this.radio = '上海直销';
                    this.agentType = 1;
                } else if (response.obj.customerassigngroupSell === '0260' || response.obj.agentTypeBas == '3') {
                    this.radio = '海外客户';
                    this.agentType = 3;
                    this.isShowMassage = false;
                }
            })
        },
        methods: {
            findAddress() {
                ss.SignService.selectAddress().then(response => {
                    this.addli = response;
                })
            },
            viewpress() {
                this.showhistory = true;
            },
            handleIconClick() {
                this.showflag = true;
            },
            choseObj(obj) {
                console.log(obj)
                this.showflag = false;
                if (obj.zhenobj && obj.zhenobj.name) {
                    this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.zhenobj.name + ' ' + obj.addrdetail;
                } else {
                    this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.addrdetail;
                }
            },
            changeType(v) {
                if (v === '海外客户') {
                    this.agentType = 3;
                    this.isShowMassage = false;
                    this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0260';
                    this.formLabelAlign1.bscUserInfoAgentBasic.country = '';
                    this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
                    this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0260';
                } else if (v === '上海直销') {
                    this.agentType = 1;
                    this.isShowMassage = true;
                    // this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0210';
                    // this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
                    // this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122001000';
                    // this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
                    // this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0210';
                    this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0280';
                    this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
                    this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
                    this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
                    this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0280';
                } else if (v === '国内客户') {
                    this.agentType = 2;
                    this.isShowMassage = true;
                    this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0280';
                    this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
                    this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
                    this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
                    this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0280';
                }
            },
            //通过审批按钮功能
            update() {
                // this.formLabelAlign1.bscUserInfo.status = '4';
                // this.modelList.push(this.formLabelAlign1);
                // ss.SignService.update(this.modelList).then(response => {
                //     console.log(response)
                // })
                this.formLabelAlign1.bscUserInfoAgentBasic.aaa = 1;
                this.formLabelAlign1.bscUserInfoAgentBasic.taskid = this.taskid;
                this.formLabelAlign1.ywid = this.$route.query.ywid;
                // this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms = 'CFR';
                // this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2 = 'CIF';
                console.log(this.formLabelAlign1, '提交时的数据')
                agentCopyService.agentPassFenxiao(this.formLabelAlign1).then(rd => {
                    this.$msg.alerts("提交成功！", () => {
                        //刷新右上角的代办个数
                        this.$store.dispatch("searchTasktotal")
                        //跳转回系统的代办列表
                        this.$router.push({
                            path: '/personal/dealCenter'
                        })
                    })
                });

            },
            //驳回按钮功能
            reject(data) {

            },
            //经销商查看功能对应展示数据功能
            checkDetail() {
                this.formLabelAlign1.bscUserInfoAgentBasic.usercode = this.data.usercode

                this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = this.data.customername1
                if (this.data.scaleBas !== undefined) {
                    this.formLabelAlign1.bscUserInfoAgentBasic.scale = this.data.scale.toString()
                }
                this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = this.data.iszhidanBas
                this.formLabelAlign1.bscUserInfoAgentBasic.agentType = this.data.agentTypeBas
                if (this.data.iszhidan == 1) {
                    this.isZhiDan = true;
                }
                if(this.data.isExpandAuthority == 1){
                    this.isExpandAuthority =true
                }
                if(this.data.isBlood == 1){
                    this.isBlood = true
                }
                if(this.data.isFenxiao == 1){
                    this.isFenxiao = true
                }
                this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress = this.data.companyAddress
                this.formLabelAlign1.bscUserInfoAgentBasic.postalCode = this.data.postalCode
                this.formLabelAlign1.bscUserInfoAgentBasic.faxNumber = this.data.faxNumber
                this.formLabelAlign1.bscUserInfoAgentBasic.http = this.data.http
                this.formLabelAlign1.bscUserInfoAgentBasic.companytype = this.data.companytype
                this.formLabelAlign1.bscUserInfoAgentBasic.founded = this.data.founded
                this.formLabelAlign1.bscUserInfoAgentBasic.regmoney = this.data.regmoney
                this.formLabelAlign1.bscUserInfoAgentBasic.legal = this.data.legal
                this.formLabelAlign1.bscUserInfoAgentBasic.introduce = this.data.introduce
                this.formLabelAlign1.bscUserInfoAgentBasic.business = this.data.business
                this.formLabelAlign1.bscUserInfoAgentBasic.achievement = this.data.achievement
                this.formLabelAlign1.bscUserInfoAgentBasic.resource = this.data.resource
                this.formLabelAlign1.bscUserInfoAgentBasic.legalPhone = this.data.legalPhone
                this.formLabelAlign1.bscUserInfoAgentBasic.brand = this.data.brand
                this.formLabelAlign1.bscUserInfoAgentBasic.personnelNum = this.data.personnelNum
                this.formLabelAlign1.bscUserInfoAgentBasic.name1 = this.data.name1
                this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.data.phoneNumber1
                this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone = this.data.contactMobilePhone
                this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = this.data.customerName1
                this.formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom = this.data.cityStreetRoom
                this.formLabelAlign1.bscUserInfoAgentBasic.streetRoom = this.data.streetRoom
                this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber = this.data.phoneNumber
                this.formLabelAlign1.bscUserInfoAgentBasic.postalCode = this.data.postalCode
                this.formLabelAlign1.bscUserInfoAgentBasic.name1 = this.data.name1
                this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.data.phoneNumber1
                this.formLabelAlign1.bscUserInfoAgentBasic.remark = this.data.remark
                this.formLabelAlign1.bscUserInfoAgentBasic.email = this.data.email
                this.formLabelAlign1.bscUserInfoAgentBasic.contactCity = this.data.contactCity
                this.formLabelAlign1.bscUserInfoAgentBasic.appellation = this.data.appellation
                this.formLabelAlign1.bscUserInfoAgentBasic.country = this.data.country
                this.formLabelAlign1.bscUserInfoAgentBasic.region = this.data.region
                this.formLabelAlign1.bscUserInfoAgentBasic.companyCodeGeneral = this.data.companyCodeGeneral
                this.formLabelAlign1.bscUserInfoAgentBasic.companyCode = this.data.companyCode
                this.formLabelAlign1.bscUserInfoAgentBasic.taxCode = this.data.taxCode
            },
            goBack() {
                this.$router.push({
                    path: '/agent/agentCopy'
                })
            },
            go(index) {
                this.indx = index;
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${file.name}？`);

            },
            toLogin() {
                this.$router.push({
                    path: '/login'
                })
            }
        },
        mounted() {
            this.flag = this.$route.query.index;
            console.log(this.flag, 'flag');
            if (this.flag === '2') {
                this.uploadflag = false;
                this.delflag = false;
                this.data = this.$route.query;
                this.rules = {};
                this.checkDetail();
            } else if (this.flag === '3') {
                this.uploadflag = false;
                this.delflag = false;
                this.data = this.$route.query;
                this.rules = {};
                this.checkDetail();
            }
        }
    }
</script>
<style scoped>
    .zhanghu {
        margin-bottom: 40px;
    }

    .imgBox {
        width: 100%;
    }

    .bannerBox {
        width: 100%;
        padding: 0.22rem 0.38rem 0 0.32rem;
        margin: 0 auto;
    }

    .whiteBox {
        width: 100%;
        padding: 0.22rem 0.26rem;
        background-color: #ffffff;
    }

    .titles {
        font-size: 0.16rem;
        color: #0e75e9;
        position: relative;
        padding-left: 9px;
        border-left: 0.05rem solid #0e75e9;
        font-weight: bold;
    }
    .h-formbLine .h-elformWrap-2 {
        padding-right: 0
    }
    .el-switch__label{

    }
</style>
<style >
    .passfollow {
        position: absolute;
        right: 0;
        bottom: 0.3rem;
        background-color: #2785e7;
        color: white;
    }

    /*    .signsign .h-formbLine .el-form-item__content .el-select {
        width: 100% !important;
    } */

    .zhanghu .h-formbLine .el-form-item__label,
    .signsign .h-formbLine .el-form-item__label {
        width: 44%;
    }

    .signsign .h-formbLine .h-elformWrap-3 .el-form-item__label {
        width: 12.5%;
    }

    .signsign .h-formbLine .h-elformWrap-3 {
        width: 100%;
        padding-right: 1rem;
    }

    .signsign .h-formbLine .h-elformWrap-3 .el-form-item__content {
        width: 87.5%;
    }

    .signsign .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 0%;
    }

    .signsign .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 100%;
    }

    .zhanghu .h-formbLine .el-form-item__content,
    .signsign .h-formbLine .el-form-item__content {
        width: 56%;
    }

    .zhanghu .h-formbLine .h-elformWrap-2,
    .signsign .h-formbLine .h-elformWrap-2 {
        width: 25%;
    }

    .weekplandetail11 .h-formbLine .el-form-item__label {
        width: 45%;
    }

    .weekplandetail11 .h-formbLine .el-form-item__content {
        width: 50%;
    }

    .bannerBox2 .el-form-item__content {
        width: 85%;
    }

    .bannerBox2 .el-input__inner {
        border: none;
        border-bottom: 1px solid #DCDFE6;
    }
</style>
